import { render } from "./MemorizeYourBirthday.vue?vue&type=template&id=796bcdd6&scoped=true"
import script from "./MemorizeYourBirthday.vue?vue&type=script&lang=js"
export * from "./MemorizeYourBirthday.vue?vue&type=script&lang=js"

import "./MemorizeYourBirthday.vue?vue&type=style&index=0&id=796bcdd6&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796bcdd6"]])

export default __exports__